import React, {useEffect} from 'react';
import styles from './_iframe-test-page.module.scss';

// IFramePage Component
interface IframeTestPageProps {
  iframeSrc: string;
}

export const IframeTestPage = (props: IframeTestPageProps) => {
  const [isLoading, setIsLoading] = React.useState(true);

  const handleIFrameLoad = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.event === 'redirect' && event.data?.redirectUrl) {
        console.log('Forward event received, redirectUrl:', event.data.redirectUrl);

        // Do something with the URL
        window.location.href = event.data.redirectUrl;
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <div className={styles.iframePage}>
      <div className={styles.topContent}>
        <div className={styles.contentWrapper}>
          <h1>Page Title</h1>
          <p>This content area takes up the top 50% of the page.</p>
          <p>You can add any content here - navigation, text, images, or other components.</p>

          <div className={styles.infoSection}>
            <h2>About This Layout</h2>
            <p>The iframe below starts at 50% down the page and extends to 90% of the viewport height.</p>
            <p>Currently displaying: <code>{props.iframeSrc}</code></p>
          </div>
        </div>
      </div>

      <div className={styles.iframeContainer}>
        {isLoading && (
          <div className={styles.loadingOverlay}>
            <div className={styles.spinner}></div>
            <p>Loading content...</p>
          </div>
        )}
        <iframe
          src={props.iframeSrc}
          title="Embedded Content"
          onLoad={handleIFrameLoad}
          className={styles.embeddedIframe}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
};